import { fetchData, apiURL } from "../api-helper";

// ADMIN SETTINGS

// GET ADMIN SETTINGS LIST
const getAdminSettings = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/settings`;
    fetchData(endpointURL, "get", null)
        .then((result) => {
            resolve(result);
        })
        .catch((error) => {
            reject(error);
        });
});

const updateAdminSettings = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/settings`;
    fetchData(endpointURL, "put", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
});

const getLanguages = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/language`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
});
 
export default {
  getAdminSettings,
  updateAdminSettings,
  getLanguages
};